import { Country } from '@/models/country.interface';
import axios from 'axios';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module
export default class CountryStore extends VuexModule {
  /* tslint:disable */
  private _countries: Array<Country> = new Array();
  private _isFetched: boolean = false;
  /* tslint:enable */

  @Mutation
  public setCountriesMut(countries: Country[]) {
    this._countries = countries;
    this._isFetched = true;
  }

  @Action({ commit: 'setCountriesMut' })
  public async getCountriesAction(): Promise<Country[]> {
    try {
      const response = await axios.get(`${process.env.VUE_APP_API_URL}/country`);
      return response.data;
    } catch (err) {
      return [];
    }
  }

  get countries(): Country[] {
    return this._countries;
  }

  get isCountriesFetched(): boolean {
    return this._isFetched;
  }
}
